import { store } from '@utils/configStore'
import { notificationManagementReducer } from './slice'

export const injectNotificationManagementStore = () => store.injectReducer('notificationManagement', notificationManagementReducer)
